import { RenderFields } from "digimaker-ui";
import { FetchWithAuth } from "digimaker-ui/util";
import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";

export const Update = (props: { id?: number }) => {
  const mode = props.id ? "edit" : "add";
  const [list, setList] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [schoolID, setSchoolID] = useState(0);
  const [showSearchResult, setShowSearchResult] = useState(false);

  const [data, setData] = useState({});

  const fetchSchools = () => {
    FetchWithAuth("matchfit/school/list?q=" + keyword).then((data) => {
      if (data.error === false) {
        setList(data.data);
        setShowSearchResult(true);
      }
    });
  };

  const fetchData = (id) => {
    FetchWithAuth("content/get/school_image/" + id).then((data) => {
      if (data.error === false) {
        const content = data.data;
        setData({
          image: content.image,
          image_type: content.image_type,
          school_id: content.school_id,
        });
        setSchoolID(content.school_id);
      }
    });
  };

  const selectSchool = (id) => {
    setSchoolID(id);
    setShowSearchResult(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = new FormData(e.target);
    const dataObject = {};
    for (let key of Array.from(form.keys())) {
      dataObject[key] = form.get(key);
    }

    if (mode === "add") {
      dataObject["school_id"] = schoolID;

      if (!schoolID) {
        window.alert("Need school id");
        return;
      }

      FetchWithAuth("content/create/school_image", {
        method: "POST",
        body: JSON.stringify(dataObject),
      }).then((data) => {
        if (data.error === false) {
          console.log("Success");
          window.location.href = "/";
        } else {
          window.alert(data.data.message);
        }
      });
    } else if (mode === "edit") {
      FetchWithAuth("content/update/school_image/" + props.id, {
        method: "POST",
        body: JSON.stringify(dataObject),
      }).then((data) => {
        if (data.error === false) {
          console.log("Success");
          window.location.href = "/";
        } else {
          window.alert(data.data.message);
        }
      });
    }

    return false;
  };

  useEffect(() => {
    if (props.id) {
      fetchData(props.id);
    } else {
      fetchSchools();
    }
  }, [props.id]);

  return (
    <div className="container">
      <div>
        <h2 className="h2">{props.id ? "Update" : "Add"} school image</h2>
        {!props.id && (
          <div>
            <label>School search:</label>
            <input
              placeholder="Input to search"
              type="text"
              onChange={(e) => setKeyword(e.target.value)}
              value={keyword}
              style={{ width: 150, display: "inline-block", margin: "0px 5px" }}
              className="form-control"
            />
            <Button
              size="sm"
              variant="secondary"
              onClick={() => fetchSchools()}
            >
              Search
            </Button>
          </div>
        )}
        {list.length > 0 && showSearchResult && (
          <div
            style={{
              maxHeight: 200,
              overflowY: "auto",
              padding: 5,
              marginTop: 10,
              border: "1px solid #f0f0f0",
              cursor: "pointer",
            }}
          >
            {list.map((item: any) => (
              <div
                onClick={() => selectSchool(item.id)}
                style={{
                  fontWeight: item.id === schoolID ? "bold" : "normal",
                }}
              >
                {item.name}
              </div>
            ))}
          </div>
        )}
      </div>

      <div style={{ fontWeight: "bold" }}>
        {(list.find((item: any) => item.id === schoolID) as any)?.name}
      </div>

      <form onSubmit={(e) => handleSubmit(e)}>
        <div key={schoolID}>
          <RenderFields
            mode="edit"
            type={"school_image"}
            data={data}
            validation={null}
          />
        </div>

        <div>
          <br />
          <Button type="submit" size="sm">
            Submit
          </Button>{" "}
          &nbsp;
          <Button
            size="sm"
            variant="light"
            onClick={() => window.history.back()}
          >
            Cancel
          </Button>
        </div>
      </form>
    </div>
  );
};
